import { createGlobalStyle } from 'styled-components';
import { device, scales } from './constants';

export const BASE_FONT_SIZE = 16;

export const GlobalMainAppStyles = createGlobalStyle`
  body {
    background-color: #01474e;
  }

  #root-assessment-tool {
    position: absolute;
    height: 100%;
    width: 100%;
  }

`;

export const GlobalRedboxAppStyles = createGlobalStyle`
  #root-assessment-tool {
    background-color: #01474e;
    position: relative;
    height: 1050px;

    @media ${device.tabletP} {
      height: 866px;
    };

    @media ${device.tabletL} {
      height: 858px;
    };

    @media ${device.laptop} {
      height: 885px;
    };

    @media ${device.desktop} {
      height: 930px;
    };
  }
`;

interface GlobalSharedStylesProps {
  backendPath: string;
}

export const GlobalSharedStyles = createGlobalStyle<GlobalSharedStylesProps>`
  /*  Bold */
  @font-face {
    font-family: "Delivery";
    font-display: block;
    src: ${({ backendPath }) =>
      `url(${backendPath}/assets/fonts/Delivery_W_Bd.woff2) format("woff2")`};
    font-weight: 700;
    font-style: normal;
  }

  /*  Condensed Black */
  @font-face {
    font-family: "Delivery";
    font-display: block;
    src: ${({ backendPath }) =>
      `url(${backendPath}/assets/fonts/Delivery_W_CdBlk.woff2) format("woff2")`};
    font-weight: 800;
    font-stretch: condensed;
    font-style: normal;
  }

  /*  Regular */
  @font-face {
    font-family: "Delivery";
    font-display: block;
    src: ${({ backendPath }) =>
      `url(${backendPath}/assets/fonts/Delivery_W_Rg.woff2) format("woff2")`};
    font-weight: 400;
    font-style: normal;
  }

  #root-assessment-tool {
    font-family: Delivery, Verdana, sans-serif;
    font-size: ${BASE_FONT_SIZE * scales.laptop}px;
    font-weight: 700;
  }

  #root-assessment-tool * {
    box-sizing: border-box;
  }

  #root-assessment-tool button {
    appearance: button;
    border: 0;
    cursor: pointer;
    font-family: Delivery, Verdana, sans-serif;
    overflow: visible;
    text-transform: none;
  }
`;
